const DEFAULT_CONTACT_EMAIL = 'contact@scubeaiconsulting.in';

const runtimeConfig =
  typeof window !== 'undefined' && window.SCUBE_CONFIG
    ? window.SCUBE_CONFIG
    : {};

export const CONTACT_EMAIL =
  runtimeConfig.contactEmail?.trim() || DEFAULT_CONTACT_EMAIL;

const configuredEndpoint = runtimeConfig.formEndpoint?.trim();

export const FORM_ENDPOINT =
  configuredEndpoint
    ? configuredEndpoint.startsWith('http')
      ? configuredEndpoint
      : `https://formsubmit.co/ajax/${configuredEndpoint}`
    : `https://formsubmit.co/ajax/${CONTACT_EMAIL}`;

export function buildMailtoUrl(subject, fields) {
  const body = Object.entries(fields)
    .filter(([, value]) => value)
    .map(([label, value]) => `${label}: ${value}`)
    .join('\n');

  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export async function submitWebsiteForm({ subject, replyTo, fields, honeypot }) {
  if (honeypot) {
    return { ignored: true };
  }

  const payload = new FormData();
  payload.append('_subject', subject);
  payload.append('_replyto', replyTo);
  payload.append('_template', 'table');
  payload.append('_honey', '');

  Object.entries(fields).forEach(([label, value]) => {
    if (value) {
      payload.append(label, value);
    }
  });

  const response = await fetch(FORM_ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: payload,
  });

  let result = null;

  try {
    result = await response.json();
  } catch {
    result = null;
  }

  if (
    !response.ok ||
    result?.success === false ||
    result?.success === 'false'
  ) {
    throw new Error(
      result?.message || 'The message could not be delivered. Please try again.',
    );
  }

  return result;
}
